var exports = {
  "tp": "FeatureComparisonTable.module__table___Q3V3c0",
  "wx": "FeatureComparisonTable.module__header___Q3V3c0",
  "_j": "FeatureComparisonTable.module__headerFeature___Q3V3c0",
  "t_": "FeatureComparisonTable.module__headerFeatureText___Q3V3c0",
  "UE": "FeatureComparisonTable.module__headerValues___Q3V3c0",
  "LX": "FeatureComparisonTable.module__headerRestricted___Q3V3c0",
  "_b": "FeatureComparisonTable.module__headerStock___Q3V3c0",
  "Ge": "FeatureComparisonTable.module__rows___Q3V3c0",
};

module.exports = exports;
